import axios from "axios";

const API_BASE_URL =
  "https://mohemedadmin.digitalbusinesscardnfc.com/api/data";

export const data_api = "https://mohemedadmin.digitalbusinesscardnfc.com/";

export const fetchUserData = async (name) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${name}`);
    console.log("API Response:", response); 
    console.log("Data:", response.data); 
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error.response ? error.response.data : error.message);
    throw error;
  }
};
